import { render, staticRenderFns } from "./match_machine.vue?vue&type=template&id=a803d1f2&scoped=true&"
import script from "./match_machine.vue?vue&type=script&lang=js&"
export * from "./match_machine.vue?vue&type=script&lang=js&"
import style0 from "./match_machine.vue?vue&type=style&index=0&id=a803d1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a803d1f2",
  null
  
)

export default component.exports